// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import './style/common.css'
import 'echarts'
import 'echarts-gl'
import $ from '@/util/js/jquery.min.js'
import { toFixedEnhance } from '@/util/commonTools.js';

import moment from"moment";//导入文件
Vue.prototype.$moment =moment;//赋值使用


Vue.mixin({
  methods: {
    toFixedEnhance,
  },
});

//正式华为云
//hostname = "123.60.7.64";
//测试腾讯云
//hostname = "122.51.158.194"
Vue.prototype.$hostname = '122.51.158.194';
Vue.prototype.$isShowLogo = false;

Vue.config.productionTip = false
import less from 'less'
Vue.use(less)
Vue.use(VueRouter)
Vue.use(ElementUI);
window.router = router
Vue.filter('numFormat', (val) => {
    return (Number(val) || 0).toFixed(2)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js